import { render, staticRenderFns } from "./printers.vue?vue&type=template&id=495decde&scoped=true&"
import script from "./printers.vue?vue&type=script&lang=js&"
export * from "./printers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495decde",
  null
  
)

export default component.exports